import axiosInstance from '../../../services/axios/axios';

//fetch IMS Log Data
export const GetCmsObjects = async () => {
	try {
		const url = 'api/Cms/Objects';
		const response = await axiosInstance.get(url);
		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const GetCmsObjectdetail = async id => {
	try {
		const response = await axiosInstance.get(
			`api/Cms/Objects/Detail?id=${id}`
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const UpdateCmsObject = async cmsObject => {
	try {
		const response = await axiosInstance.patch(
			`api/Cms/Objects/Update`,
			cmsObject
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const DeleteCmsObject = async cmsObject => {
	try {
		const response = await axiosInstance.patch(
			`api/Cms/Objects/Delete`,
			cmsObject
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const CreateCmsObject = async cmsObject => {
	try {
		const response = await axiosInstance.post(
			`api/Cms/Objects/New`,
			cmsObject
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const GetCmsObjectTypes = async () => {
	try {
		const response = await axiosInstance.get(`api/Cms/Objects/Types`);

		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const GetCmsObjectsByType = async typeName => {
	try {
		const url = `api/Cms/Objects/getByType?typeName=${typeName}`;
		const response = await axiosInstance.get(url);
		return response;
	} catch (ex) {
		console.error('Unable to fetch CMS objects' + ex);
		return {
			data: [],
			error: 'Unable to fetch CMS objects',
		};
	}
};

export const GetAllRoles = async () => {
	try {
		const url = `api/Roles/getRoles`;
		const response = await axiosInstance.get(url);
		return response;
	} catch (ex) {
		console.error('Unable to fetch Roles list' + ex);
		return {
			data: [],
			error: 'Unable to Roles list',
		};
	}
};
